const program_address = '6zGyXJF7ELaMas19ZxxbRsD1HuewjZWzDP1MEFFtP8gC';

const vault_pda = 'rich_tornado_vault';

const server_url = 'https://shadowbackend.whirlpoolswap.com'

const chain = 'devnet';

export {
    program_address,
    vault_pda,
    server_url,
    chain
}
